import React, { FC } from 'react';
import { Result, Button } from 'antd';
import { RouteProps, useLocation } from 'react-router';
import { Route, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useLocale } from '@app/locales';
import { useAuthStore } from '@app/modules/Auth/hooks';
import { PATH } from '@app/constants';

const PrivateRoute: FC<RouteProps> = props => {
  const { isUserLoggedIn } = useAuthStore();
  const navigate = useNavigate();
  const { formatMessage } = useLocale();
  const location = useLocation();

  return isUserLoggedIn ? (
    <Route {...props} />
  ) : (
    <Result
      status="403"
      title="403"
      subTitle={formatMessage({ id: 'gloabal.tips.unauthorized' })}
      extra={
        <Button
          type="primary"
          onClick={() => navigate(PATH.LOGIN, { replace: true, state: { from: location.pathname } })}
        >
          {formatMessage({ id: 'gloabal.tips.goToLogin' })}
        </Button>
      }
    />
  );
};

export default observer(PrivateRoute);
